import { render, staticRenderFns } from "./Aumento.vue?vue&type=template&id=dff1c580&scoped=true"
import script from "./Aumento.vue?vue&type=script&lang=js"
export * from "./Aumento.vue?vue&type=script&lang=js"
import style0 from "./Aumento.vue?vue&type=style&index=0&id=dff1c580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff1c580",
  null
  
)

export default component.exports